// Accordion
$(function () {
    $('.accordion-heading').next().hide();

    function toggle(headings, show) {
        // Blendet den Inhalt zu einer oder meherern Überschriften abhängig von show ein und aus
        headings.toggleClass('accordion--active', show);
        headings.next().stop(true)[show ? 'slideDown' : 'slideUp'](300);
        headings.children('.fas').toggleClass('fa-plus', !show).toggleClass('fa-minus', show);
        if (show)
            if (!isInViewport(headings)) {
                // is not in viewport then scroll to it
                window.setTimeout(function () {
                    $('html, body').animate({
                        scrollTop: headings.offset().top - 150
                    }, 600)
                }, 300);
            }
    }

    $('body').on('click', '.accordion-heading', function () {
        var hl = $(this);

        if (hl.hasClass('accordion--active')) {
            toggle(hl, false);
        } else {
            toggle($('.accordion-heading').not(hl), false);
            toggle(hl, true);
        }
    });
});

// is in viewport
function isInViewport(element) {
    var rect = element[0].getBoundingClientRect();

    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var elementMidpoint = (rect.top + rect.bottom) / 2;

    // Calculate the minimum and maximum acceptable positions for the element midpoint
    var minMidpoint = viewportHeight / 4; // Change this value based on your requirement
    var maxMidpoint = (3 * viewportHeight) / 4; // Change this value based on your requirement

    return elementMidpoint >= minMidpoint && elementMidpoint <= maxMidpoint;
}